import { Box, useColorModeValue } from '@chakra-ui/react';

import PropTypes from 'prop-types';

import NavigationContent from './NavigationContent';

function SideNavigation({ id }) {
  return (
    <Box
      bg={useColorModeValue('white', 'gray.800')}
      color={useColorModeValue('gray.600', 'white')}
      rounded="sm"
      py="6"
      w="200px"
      minWidth="200px"
      borderRight={1}
      borderStyle="solid"
      borderColor={useColorModeValue('gray.300', 'gray.900')}
      hideBelow="lg"
    >
      <NavigationContent id={id} />
    </Box>
  );
}

SideNavigation.propTypes = {
  id: PropTypes.number.isRequired,
};

export default SideNavigation;
